module.exports = __webpack_public_path__ + "static/img/no4.dc95929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardPH/img/no4.png
// module id = eVds
// module chunks = 1